/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Não vender nem compartilhar as minhas informações pessoais",
      "Bumble Date",
      "Nossos apps",
      "Sobre",
      "Vagas",
      "Fale conosco",
      "Investidores",
      "Loja",
      "Empresa",
      "Baixe o app",
      "Acessibilidade no Bumble",
      "Regras",
      "Gerenciar cookies",
      "Lei sobre Escravatura Moderna",
      "Notificação de coleta de dados",
      "Política de privacidade",
      "Termos e Condições",
      "Jurídico",
      "Política de Privacidade da Washington Consumer Health",
      "Escaneie o QR code para baixar o app do Bumble",
      "Encerrar contratos aqui",
      "Fechar menu",
      "Abrir menu",
      "Selecionar idioma",
      "Rodapé",
      "Acessibilidade no Bumble",
      "A Apple e o logotipo da Apple são marcas comerciais da Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Vagas",
      "O Google Play é uma marca registrada da Google LLC.",
      "Regras",
      "Investidores",
      "Gerenciar Cookies",
      "Lei sobre Escravatura Moderna (Reino Unido)",
      "Notificação de coleta de dados",
      "Política de Privacidade",
      "Guias de encontros sazonais",
      "Termos e Condições",
      "App",
      "Política de privacidade de dados de saúde do consumidor de Washington",
      "Sobre",
      "Embaixadores",
      "Conheça pessoas e faça novas amizades",
      "Desenvolva sua rede profissional e impulsione sua carreira",
      "Encontre um relacionamento, algo casual ou alguém interessante no meio do caminho.",
      "O Buzz",
      "Saiba mais",
      "Viaje pelo mundo com o Modo Viagem",
      "Date",
      "Recursos",
      "Compliments",
      "Envie alguns Compliments e ganhe destaque na multidão.",
      "Descubra",
      "Uma página personalizada que destaca as pessoas mais compatíveis com você, atualizada todos os dias.",
      "Modo Invisível",
      "Esconda seu perfil de todo mundo com o Modo Invisível.",
      "Conexão imediata",
      "Iniciou uma conversa pessoalmente em um evento do Bumble? Continue no aplicativo.",
      "Opening Moves",
      "Escolha um Opening Moves para convidar sua conexão para iniciar uma conversa, para que você não precise fazer isso.",
      "Modo Não Perturbe",
      "Reserve um momento para você com o Modo Não Perturbe. Quando quiser voltar, você sabe onde nos encontrar.",
      "SuperSwipe",
      "Curtiu o perfil de alguém? Mostre enviando um SuperSwipe.",
      "Modo Viagem",
      "Encontre sua felicidade em qualquer lugar do mundo graças ao Modo Viagem.",
      "Chamadas de vídeo",
      "Use chamadas de vídeo e áudio para verificar se você está pronto para se encontrar pessoalmente.",
      "Aplicativo Web",
      "Ative a experiência do Bumble diretamente do seu navegador.",
      "Baixar o app do Bumble",
      "BFF",
      "Segurança",
      "Histórias",
      "Suporte",
      "Loja",
      "Principal",
      "Envie alguns Compliments e ganhe destaque.",
      "Compliments",
      "Recursos projetados para criar espaço para conexões reais, respeitosas e de verdade.",
      "Esconda seu perfil de chefes, de entes queridos ou de ex.",
      "Modo Invisível",
      "Reserve um momento para você com o Modo Não Perturbe.",
      "Modo Não Perturbe",
      "Curtiu alguém? Deixe claro!",
      "SuperSwipe",
      "Explorar os Date",
      "Conheça pessoas do mundo todo.",
      "Modo Viagem",
      "Chegue o mais perto possível da vida real sem sair de casa.",
      "Chamadas de vídeo",
      "Nossos líderes ajudam a trazer os valores do Bumble para suas comunidades em todo o país.",
      "Líderes da Comunidade",
      "Recursos projetados para ajudar você a encontrar pessoas com ideias semelhantes e se conectar com outras com base em seus pontos em comum.",
      "Organize um encontro em grupo, ou descubra eventos locais acontecendo nas proximidades.",
      "Planos",
      "Explorar o BFF",
      "Toda a orientação e inspiração que você precisa para te ajudar a encontrar amor e amizade.",
      "Conselhos e histórias para ajudar a construir as amizades que você deseja.",
      "Centro de Amizade",
      "De Tóquio a Toronto, explore o amor encontrado no Bumble ao redor do mundo.",
      "Histórias de Amor",
      "Planeje o encontro perfeito, não importa quando, onde ou com quem você esteja saindo.",
      "Guias de encontros sazonais",
      "Explorar Histórias",
      "Ler mais",
      "Bumble no {{social_network}}",
      "Contato",
      "Entrar",
      "(abre em nova janela)",
      "FAQ",
      "Política de Cookies",
      "Blog do Bumble",
      "Vagas",
      "Conversas",
      "Cidades",
      "Gerenciar cookies",
      "Copyright © 2006 – presente. Bumble. Todos os direitos reservados.",
      "Relatório de Encontros com Confiança",
      "Apple e o logotipo da Apple são marcas comerciais da Apple Inc.{{__EOL__}}Google Play é uma marca registrada da Google LLC.",
      "Baixe o app",
      "Facebook",
      "Siga-nos",
      "Central de Ajuda",
      "Instagram",
      "Idioma",
      "LinkedIn",
      "O Bumble faz parte da Bumble Inc.",
      "Política de privacidade",
      "Safety Centre",
      "Mapa do site",
      "Declaração da Lei Modern Slavery Act",
      "Termos e condições",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dias"
            ],
            "singular": [
                  "dia"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mês"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "anos"
            ],
            "singular": [
                  "ano"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
